import type { HowItWorkItem } from '~/components/pages/directions/how-it-work-section/how-it-works.types'

const HOW_IT_WORK_CONFERENCE_SYSTEM: HowItWorkItem = {
    cards: [
        {
            id: 1,
            title: '',
            description:
                '1. Микрофоны быстро расставляются на&nbsp;столы, соединяясь по&nbsp;цепочке друг с&nbsp;другом, используя минимальный объем кабелей',
            alt: 'Соединение микрофонов цепочкой',
            width: 880,
            height: 472,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/microphone-circuit-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/microphone-circuit.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/microphone-circuit-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/microphone-circuit.webp',
        },
        {
            id: 2,
            title: '',
            description:
                '2. Благодаря встроенным в&nbsp;пульты динамикам, участники могут слышать друг друга на&nbsp;большом расстоянии',
            alt: 'Пульты, встроенные в динамики',
            width: 880,
            height: 592,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/speakers-in-consoles-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/speakers-in-consoles.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/speakers-in-consoles-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/speakers-in-consoles.webp',
        },
        {
            id: 3,
            title: '',
            description:
                '3. При необходимости, председатель (модератор) мероприятия может принудительно выключить все микрофоны, контролируя организованность выступлений',
            alt: 'Контроль организованности выступлений',
            width: 880,
            height: 450,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/microphone-cutoff-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/microphone-cutoff.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/microphone-cutoff-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/microphone-cutoff.webp',
        },
    ],
    video: {
        title: 'А как в работе',
        name: 'Как используется',
        description:
            'Конференц-системы Reinvox в&nbsp;реальной работе на&nbsp;мероприятии',
        width: 400,
        height: 225,
        video_preview:
            '/assets/images/usage/conference-system/jpg-png/conference-room.png',
        video_preview_webp:
            '/assets/images/usage/conference-system/webp/conference-room.webp',
        duration: '0:38',
        link: '6ff903c66ecbfad78b2224945ea9f82d',
    },
}

export default HOW_IT_WORK_CONFERENCE_SYSTEM
